export type AppConfig = {
    tenantId: string;
    head: {
        title: string;
        description: string;
        iconBase: string;
        iconVersion: string;
    };
};

declare global {
    interface Window {
        __APP_CONFIG__?: AppConfig;
    }
}

const mockConfig: AppConfig = {
    tenantId: "com",
    head: {
        title: "Secure login to your Banxe account | Banxe",
        description: "Log in to your Banxe account to manage payments, cards, currency exchange and crypto services securely from one unified platform.",
        iconBase: "/tenants/com/img/favicons/",
        iconVersion: "16022026", // update when changes favicons
    },
}

export function getAppConfig(): AppConfig {
    const cfg = window.__APP_CONFIG__
    // TODO: uncomment before NeuroNext on prod
    // if (!cfg) throw new Error("APP_CONFIG is missing. Check /config.js in index.html")
    return !cfg ? mockConfig : cfg
}
